// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import { i18nReady } from "./i18n/i18n";
import App from './App';
import { AuthProvider, msalInstance } from "./providers/AuthContext";
import { MsalProvider } from '@azure/msal-react';
import { Toaster } from 'react-hot-toast';
import { brand, chartSeriesColors } from './theme/gitoColors';

// ApexCharts global palette — blue series use GITO primary
window.Apex = {
  ...(window.Apex || {}),
  colors: chartSeriesColors,
};

const root = ReactDOM.createRoot(document.getElementById('root'));

i18nReady.catch((error) => {
  console.error(error);
}).then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <Toaster toastOptions={{
              className: 'text-sm font-bold text-black',
              success: {
                iconTheme: {
                  primary: brand.turquoise,
                  secondary: brand.white,
                },
                },
                error: {
                  iconTheme: {
                    primary: brand.puls,
                    secondary: brand.white,
                  },
                  },
                  loading: {
                    iconTheme: {
                      primary: brand.darkBlue,
                      secondary: brand.lightBlue,
                    },
                    },
            }} />
          </AuthProvider>
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>
  );
});
